import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns, getIcon } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi, OrderArrowsUI } from '../Interface';
import otherActivityService from '../../service/otherActivity.service';

export const OtherActivityReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [orderChanged, setOrderChanged] = useState(false);
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: {
      filterModel: { items: [], logicOperator: 'and' },
    },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    otherActivityService.getRows(gridState).then((data) => {
      setReports(data);
    });
  };

  const orderData = (id, newOrder) => {
    otherActivityService.orderData(id, { newOrder }).then((data) => {
      setRefetchTable(true);
    });
  };

  const handleOrderChange = (id, direction) => {
    orderData(id, direction);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'icon',
      headerName: 'Ikon',
      type: 'string',
      sortable: false,
      filterable: false,
      renderCell: (data) => {
        return getIcon(data.row.icon, '1.7rem');
      },
    },
    {
      field: 'visOrder',
      headerName: 'Sorrend',
      type: 'action',
      renderCell: (params) => {
        const disabled = params?.api?.getSortModel()[0]?.field !== 'visOrder';
        const isSortedDescending = params.api.getSortModel()[0]?.sort === 'desc';

        const handleUpClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'down');
          } else {
            handleOrderChange(params.row.id, 'up');
          }
        };

        const handleDownClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'up');
          } else {
            handleOrderChange(params.row.id, 'down');
          }
        };

        return <OrderArrowsUI onUpClick={handleUpClick} onDownClick={handleDownClick} disabled={disabled} />;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.OtherActivityReports}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
